import { InjectionToken } from '@angular/core';
import {
  IValidationMessageBuilder,
  IValidationService,
} from './validation.types';

/**
 * Multi-Provider Token for injecting validators.
 */
export const DECLARATIVE_FORMS_VALIDATOR_TOKEN = new InjectionToken<
  IValidationService[]
>('DECLARATIVE_FORMS.VALIDATOR');

/**
 * Token for injecting a validation message builder.
 */
export const DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN =
  new InjectionToken<IValidationMessageBuilder>(
    'DECLARATIVE_FORMS.VALIDATION.MESSAGE_BUILDER',
  );
